import React from 'react';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsRoutes } from '../../../shared/routing/Routes';
import { PsDropdown } from '../../../shared/components/ps-dropdown/PsDropdown';
import { PsMessageStates } from '../PsMessageStates';
import { PsMessage } from '../PsMessage';
import { MessageSearchRequest } from '../shared/message-search/MessageSearchRequest';
import { MessageSearchTask } from '../shared/message-search/MessageSearchTask';
import { MessagePreviewList } from './MessagePreviewList';

export class MessagePreviewListTrigger extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            messages: [],
            totalUnreadMessages: 0,
        };
    }

    componentDidMount() {
        this.listUnreadMessages();
    }

    render() {
        const {
            loading,
            messages,
            totalUnreadMessages,
        } = this.state;

        return (
            <PsDropdown
                icon="message"
                loading={loading}
                counter={totalUnreadMessages}
            >
                <li className="header">{I18nUtils.tr('TR_MENSAJES').toUpperCase()}</li>
                <li className="body">
                    <MessagePreviewList messages={messages}/>
                </li>
                <li className="footer">
                    <Link
                        to={RouterUtils.generateRoute(PsRoutes.MESSAGES)}
                        className="waves-effect waves-block"
                        children={I18nUtils.tr('TR_VER_TODOS_LOS_MENSAJES').toUpperCase()}
                    />
                </li>
            </PsDropdown>
        );
    }

    listUnreadMessages = () => {
        const request = new MessageSearchRequest(10);

        request.setState(PsMessageStates.ALL);

        new MessageSearchTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const messages = PsMessage.fromAPIMessages(res.data);
                const totalUnreadMessages = messages.filter((n) => !n.isRead()).length;
                this.setState({ messages, totalUnreadMessages });
            })
            .onFail((error) => Alert.error(error))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/preview-list/MessagePreviewListTrigger.jsx